document.addEventListener("DOMContentLoaded", function () {
  function getNextDropDate() {
    const firstDrop = new Date("2025-11-14T10:00:00Z").getTime();
    const now = new Date().getTime();
    const weeksInMs = 7 * 24 * 60 * 60 * 1000;

    let nextDrop = firstDrop;
    while (nextDrop < now) {
      nextDrop += weeksInMs;
    }
    return nextDrop;
  }

  function updateRitualTimer() {
    const nextDrop = getNextDropDate();
    const now = new Date().getTime();
    const distance = nextDrop - now;

    if (distance <= 0) {
      document.getElementById("ritual-timer").innerHTML = "Now Unveiling...";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hrs = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("ritual-timer").innerHTML =
      days + "d " + hrs + "h " + mins + "m " + secs + "s ";
  }

  updateRitualTimer();
  setInterval(updateRitualTimer, 1000);
});
